export default "__VITE_ASSET__f870ebfd__"